import LoginResponse from '@authentication/models/login.response.dto';
import User from '@authentication/models/user';
import axiosClient from '@services/axiosClient';

import EndPoints from '@services/endpoints';

import { AxiosResponse } from 'axios';

export const getUserByUserId = (
  username: string | null,
): Promise<AxiosResponse<User>> | null => {
  if (!username) return null;
  return axiosClient.get(EndPoints.user.getUserById(username));
};

export const getCurrentUser = (): Promise<
  AxiosResponse<LoginResponse>
> | null => {
  return axiosClient.get(EndPoints.auth.getCurrentUser);
};
